<template>
  <div
    v-if="assetAssociations.length > 0"
    class="asset-associations-list-container"
  >
    <button
      v-for="assetAssociation in assetAssociations"
      :key="assetAssociation.id"
      data-test="asset-association-button"
      @click="triggerAssetAssociationAction(assetAssociation)"
    >
      {{ assetAssociation.buttonText }}
    </button>
    <asset-association-modal
      v-if="currentAssetAssociation"
      :asset-association="currentAssetAssociation"
      @close-button-clicked="closeModal"
    />
  </div>
</template>

<script>
import AssetAssociationModal from '@components/assetAssociations/modal';

export default {
  name: 'OldAssetAssociationsList',
  components: { AssetAssociationModal },
  props: {
    asset: {
      type: Object,
    },
    context: {
      type: String,
    },
  },
  emits: ['flashcard-aa-clicked'],
  data() {
    return {
      currentAssetAssociation: undefined,
    };
  },
  computed: {
    assetAssociations() {
      if( !this.asset || !this.asset.assetAssociations) { return []; }
      // We need to filter out unsupported asset associations
      const supportedAssociations = ['Topic', 'Attachment', 'V3Flashcard', 'Grouping'];
      const exhibitsEnabled = (this.$store.getters['productVars/get']['flashcards_disable_exhibit_ids'] || {}).value === 'true';

      const associations = this.asset.assetAssociations.filter(a => {
        const supported = a.assetAContext === this.context && supportedAssociations.includes(a.assetBType) && a.displayType !== 'embed_before' && a.displayType !== 'scenario_box';
        // special case for groupings, we only support certain types
        if (supported && a.assetBType === 'Grouping') {
          const grouping = this.$store.getters['groupings/all'][a.assetBId];
          // exhibits currently must be supported via product var
          return grouping && grouping.groupingType === 'Exhibit' && exhibitsEnabled;
        }

        return supported;
      });

      return associations.sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    closeModal() {
      this.currentAssetAssociation = undefined;
    },
    triggerAssetAssociationAction(assetAssociation) {
      this[`trigger${assetAssociation.assetBType}Action`](assetAssociation);
    },
    triggerAttachmentAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerGroupingAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerTopicAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerV3FlashcardAction(assetAssociation) {
      this.$emit('flashcard-aa-clicked', assetAssociation.id);
    },
  },
};
</script>

<style lang='scss' scoped>
.asset-associations-list-container {
  button {
    background: #4fb9de;
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    box-sizing: content-box;
    color: white;
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    margin: 0 rem-calc(16) rem-calc(16) 0;
    padding: rem-calc(10) rem-calc(20);
    min-width: rem-calc(120);

    &:hover {
      background-color: hlt-darken(#4fb9de, 5);
    }
  }
}
</style>
